<template>
  <div
    :class="[
      'vl-accordion-item',
      {
        'is-open': active,
      },
    ]"
  >
    <div class="vl-accordion-item__title" role="button" @click="toggle">
      <slot name="title"></slot>
    </div>
    <transition
      name="animation-height"
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:after-enter="afterEnter"
      v-on:before-leave="beforeLeave"
      v-on:leave="leave"
    >
      <div
        class="vl-accordion-item__description"
        v-show="active"
        ref="description"
      >
        <div class="vl-accordion-item__description-inner">
          <slot name="description"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'VlAccordionItem',
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    active: false,
    height: 0,
  }),
  methods: {
    toggle() {
      this.active = !this.active
    },
    beforeEnter(el) {
      el.style.height = '0'
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    afterEnter(el) {
      el.style.height = null
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el) {
      requestAnimationFrame(() => {
        el.style.height = '0'
      })
    },
    getElementHeight() {
      return this.$refs.description.scrollHeight
    },
  },
  created() {
    this.active = this.opened
  },
  mounted() {
    this.height = this.getElementHeight()
  },
}
</script>
